import React from "react";
import HomeIcon from "@mui/icons-material/Home";
import AddIcon from "@mui/icons-material/Add";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import { Link } from "react-router";

function SideBar() {
  return (
    <div className="lg:w-2/12 min-w-[170px] flex gap-6 lg:gap-8 flex-row flex-wrap lg:flex-col px-4 py-4 lg:py-8 bg-gray-200">
      <Link
        to="/superadmin"
        className="flex flex-row gap-2 hover:bg-gray-300 p-2 items-center"
      >
        <HomeIcon />
        <span className="text-lg font-medium">Dashboard</span>
      </Link>
      <Link
        to="/superadmin/addcompany"
        className="flex flex-row hover:bg-gray-300 p-2  gap-2 items-center"
      >
        <AddIcon />
        <span className="text-lg font-medium">Add New Company</span>
      </Link>
      <Link
        to="/superadmin/manage"
        className="flex flex-row hover:bg-gray-300 p-2  gap-2 items-center"
      >
        <ManageAccountsIcon />
        <span className="text-lg font-medium">Manage Companies</span>
      </Link>
      <Link
        to="/superadmin/managesupervisor"
        className="flex flex-row hover:bg-gray-300 p-2  gap-2 items-center"
      >
        <ManageAccountsIcon />
        <span className="text-lg font-medium">Manage Supervisor</span>
      </Link>
    </div>
  );
}

export default SideBar;
